// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KZ3y","name":"styles_name__2j9Y2","phone":"styles_phone__1PJlc"};